import { FC } from 'react'
import styled from 'styled-components'

import { useFixturesContext } from '../../../../../brunswick/containers/fixtures'
import { ThreadEmojiWrapper } from '../../shared-form-styles'
import { FormBody } from '../../shared-form-styles'
import { SubmissionButtons } from '../../SubmissionButtons'
import * as Styles from '../EmbroideryLogoSetup/styles'
import { LogoFormContainer } from '../LogoFormContainer'

import { LogoColorDisplay } from './LogoColorDisplay'
import { LogoPlacement } from './LogoPlacement'
import { LogoSelector } from './LogoSelector'

export const AddEmbroideryLogo: FC = () => {
  const { addLogoForm, resetLogoForms, logoTotalPrice, hasActiveLogoSetup } =
    LogoFormContainer.useContainer()
  const { logoDigitizationDisclaimer } = useFixturesContext()

  return (
    <>
      <FormBody onSubmit={addLogoForm.handleSubmit}>
        <LogoSelector />

        <LogoPlacement />
        <LogoColorDisplay />
        <SubmissionButtons
          displayPrice={logoTotalPrice}
          disableReset={!hasActiveLogoSetup}
          onReset={() => {
            resetLogoForms()
          }}
        />
        {hasActiveLogoSetup && (
          <WarningLabel>
            <ThreadEmojiWrapper aria-label='thread' role='img'>
              🧵
            </ThreadEmojiWrapper>
            <div>{logoDigitizationDisclaimer}</div>
          </WarningLabel>
        )}
      </FormBody>
    </>
  )
}

const WarningLabel = styled(Styles.WarningLabel)`
  margin: ${({ theme }) => theme.spacing(4)} 0 0 0;
  gap: ${({ theme }) => theme.spacing(4)};
`
